import { ReactNode } from "react";
import Sidebar from "./Sidebar";
import { useSidebar } from "../context/SidebarContext";

const PageLayout = ({ children }: { children: ReactNode }) => {
  const { sidebarOpen, setSidebarOpen } = useSidebar();
  return (
    <div className="d-flex overflow-x-hidden">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <div className="main-content">{children}</div>
      {sidebarOpen && (
        <div className="overlay" onClick={() => setSidebarOpen(false)}></div>
      )}
    </div>
  );
};

export default PageLayout;
